<template>
  <div>
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
        <v-dialog
          scrollable
          v-model="userDialog"
          width="800"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              outlined
              dark
              v-bind="attrs"
              v-on="on"
              @click="editedItem = defaultItem"
            >
              Přidat uživatele
            </v-btn>
          </template>
          <UserForm
            v-if="userDialog"
            :item="editedItem"
            :food-types="availableFoodTypes"
            :districts="availableDistricts"
            @data-saved="getUsers"
          ></UserForm>
        </v-dialog>
      </v-toolbar>
    </v-card>
    <v-alert type="success" v-if="successAlert">{{message}}</v-alert>
    <v-alert type="error" v-if="errorAlert">Chyba.</v-alert>
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      :expanded="expanded"
      locale="cs"
      item-key="id"
      show-expand
      :single-expand="true"
      :loading="loading"
      @item-expanded="getBoarders"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Uživatelé</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="archive(item)"
        >
          mdi-trash-can
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getUsers">Reset</v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }" >
        <td :colspan="headers.length">
          <v-container fluid>
            <v-col cols="12">
              <v-btn
                v-if="item.maxDebt && item.debt > 0"
                @click="sendDebtAlert(item)"
                :disabled="debtAlertWait"
                color="red"
              >
                Manuálně odeslat upozornění
              </v-btn>
              <v-btn
                v-if="item.emailVerifiedAt === null"
                @click="verifyUser(item)"
                color="green"
                dark
              >
                Ověřit účet
              </v-btn>
            </v-col>
            <v-row cols="12">
              <v-col cols="6">
                <table :colspan="headers.length">
                  <tr>
                    <td>Telefon 2</td>
                    <td>{{item.phone2}}</td>
                  </tr>
                  <tr>
                    <td>Telefon 3</td>
                    <td>{{item.phone3}}</td>
                  </tr>
                  <tr>
                    <td>Interní poznámka</td>
                    <td>{{item.description}}</td>
                  </tr>
                  <tr>
                    <th>Dodací údaje</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Ulice</td>
                    <td>{{item.deliveryStreet || item.street}}</td>
                  </tr>
                  <tr>
                    <td>Č.p.</td>
                    <td>{{item.deliveryStreetNumber || item.streetNumber}}</td>
                  </tr>
                  <tr>
                    <td>Město</td>
                    <td>{{item.deliveryCity || item.city}}</td>
                  </tr>
                  <tr>
                    <td>PSČ</td>
                    <td>{{item.deliveryZip || item.zip}}</td>
                  </tr>
                  <tr>
                    <td>Městská část</td>
                    <td>{{item.deliveryCityDistrict ? item.deliveryCityDistrict.name : item.cityDistrict.name}}</td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="6">
                <table>
                  <tr>
                    <th>Firma</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Název</td>
                    <td>{{item.companyName}}</td>
                  </tr>
                  <tr>
                    <td>IČO</td>
                    <td>{{item.ico}}</td>
                  </tr>
                  <tr>
                    <td>DIČ</td>
                    <td>{{item.dic}}</td>
                  </tr>
                </table>
              </v-col>
            </v-row>
            <BoardersTable
              :boarders="expandedBoarders"
              v-if="boarderTable"
              :user="item" :institution-diets="availableDiets"></BoardersTable>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UserForm from '../../components/forms/admin/UserForm'
import BoardersTable from '../../components/BoardersTable'
export default {
  name: 'Users',
  components: { BoardersTable, UserForm },
  data () {
    return {
      successAlert: false,
      errorAlert: false,
      toggleBoardersTable: true,
      loading: true,
      debtAlertWait: false,
      search: '',
      expanded: [],
      userDialog: false,
      availableDistricts: [],
      availableDiets: [],
      availableFoodTypes: [],
      editedItem: {},
      defaultItem: {
        id: null,
        institutionName: null,
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        phone3: '',
        password: '',
        passwordAgain: '',
        street: '',
        streetNumber: '',
        city: '',
        zip: '',
        cityDistrictId: '',
        description: '',
        internalDescription: '',
        foodTypes: [],
        delivery: false,
        deliveryStreet: '',
        deliveryStreetNumber: '',
        deliveryCity: '',
        deliveryZip: '',
        deliveryCityDistrictId: null,
        company: false,
        companyName: '',
        ico: '',
        dic: '',
        maxDebt: 0,
        accountTransferEnabled: false,
        preferredCustomPackaging: false,
        debtAlert: 0,
        emailVerifiedAt: null
      },
      boarderTable: false,
      message: '',
      headers: [
        {
          text: 'Jméno',
          align: 'start',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Příjmení', value: 'lastName' },
        { text: 'Id', value: 'id' },
        { text: 'E-mail', value: 'email' },
        { text: 'Ověřeno', value: 'verified' },
        { text: 'Telefon', value: 'phone1' },
        { text: 'Instituce', value: 'institutionName' },
        { text: 'Ulice', value: 'street' },
        { text: 'č.p.', value: 'streetNumber' },
        { text: 'PSČ', value: 'zip' },
        { text: 'Město', value: 'city' },
        { text: 'Městská část', value: 'cityDistrict.name' },
        { text: 'Dluh', value: 'debt' },
        { text: 'Kredit', value: 'credit' },
        { text: 'Bankovní převod', value: 'bankTransfer' },
        { text: 'Vytvořen', value: 'createdAt' },
        { text: 'Akce', value: 'actions', sortable: false }
      ],
      users: [],
      expandedBoarders: []
    }
  },
  created () {
    this.initialize()
    this.$http.get('/admin/diets')
      .then(response => {
        this.availableDiets = this.keysToCamelCase(response.data)
          .filter(diet => diet.institutionId)
      })
  },
  methods: {
    initialize () {
      this.$http.get('/admin/city-districts')
        .then(response => {
          this.availableDistricts = this.keysToCamelCase(response.data)
            .filter(district => district.active)
            .sort(function (a, b) {
              const nameA = a.name.toUpperCase() // ignore upper and lowercase
              const nameB = b.name.toUpperCase() // ignore upper and lowercase
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
              return 0 // names are equal
            })
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.availableFoodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.getUsers()
    },
    getBoarders ({ item, value }) {
      this.boarderTable = false
      this.$http.get(`/admin/user/${item.id}/boarders`)
        .then(response => {
          this.expandedBoarders = this.keysToCamelCase(response.data)
            .map(boarder => {
              boarder.loggableStr = boarder.email ? 'Ano' : 'Ne'
              boarder.diet = boarder.diets[0]
              return boarder
            })
          this.boarderTable = true
        })
        .catch(err => console.log(err))
    },
    getUsers () {
      this.loading = true
      this.userDialog = false
      this.$http.get('/admin/roles/6')
        .then(response => {
          this.users = this.keysToCamelCase(response.data).map(user => {
            user.bankTransfer = user.paymentTransfer ? 'Ano' : 'Ne'
            user.debt = !user.maxDebt ? 'Nepovolen' : (user.credit > 0 ? 0 : user.credit * (-1))
            user.credit = user.credit > 0 ? user.credit : 0
            user.verified = user.emailVerifiedAt ? 'Ano' : 'Ne'
            user.createdAt = new Date(user.createdAt).toLocaleString('cs-CZ')
            return user
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.userDialog = true
    },
    archive (user) {
      if (!confirm(`Smazat uživatele ${user.firstName} ${user.lastName}? Tato akce je nevratná`)) {
        return
      }
      this.loading = true
      this.$http.delete(`/admin/users/${user.id}`)
        .then(() => {
          this.getUsers()
        })
        .catch(() => {
          this.showErrorAlert()
        })
        .finally(() => {
          this.loading = false
        })
    },
    sendDebtAlert (user) {
      this.debtAlertWait = true
      this.$http.post(`admin/users/${user.id}/send-debt-alert`)
        .then(() => {
          this.debtAlertWait = false
          this.showSuccessAlert('Upozornění úspěšně odesláno.')
        })
        .catch(() => {
          this.debtAlertWait = false
          this.showErrorAlert()
        })
    },
    verifyUser (user) {
      this.$http.post(`admin/users/${user.id}/verify`)
        .then(() => {
          this.showSuccessAlert('Uživatel ověřen')
          window.location.reload()
        })
        .catch(() => {
          this.showErrorAlert()
        })
    },
    showSuccessAlert (message) {
      this.message = message
      this.successAlert = true
      window.scrollTo(0, 0)
      setTimeout(() => { this.successAlert = false }, 3000)
    },
    showErrorAlert () {
      this.errorAlert = true
      window.scrollTo(0, 0)
      setTimeout(() => { this.errorAlert = false }, 3000)
    }
  },
  watch: {
    expanded (val) {
      console.log(val)
      this.toggleBoardersTable = false
      this.toggleBoardersTable = true
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.container{
}
</style>
